import { ProjectValidationError, ComponentValidationError, } from '@teleporthq/teleport-types';
import { componentUIDLDecoder, rootComponentUIDLDecoder, projectUIDLDecoder } from '../decoders';
import * as utils from './utils';
export default class Validator {
    validateComponentSchema(input) {
        try {
            const cleanedUIDL = utils.validateNulls(input);
            const uidl = componentUIDLDecoder.runWithException(cleanedUIDL);
            return { valid: true, errorMsg: '', componentUIDL: uidl };
        }
        catch (e) {
            const errorMsg = utils.formatErrors([{ kind: e.kind, message: String(e), at: e.at }]);
            throw new ComponentValidationError(errorMsg);
        }
    }
    validateRootComponentSchema(input) {
        try {
            const cleanedUIDL = utils.validateNulls(input);
            const uidl = rootComponentUIDLDecoder.runWithException(cleanedUIDL);
            return { valid: true, errorMsg: '', componentUIDL: uidl };
        }
        catch (e) {
            const errorMsg = utils.formatErrors([{ kind: e.kind, message: String(e), at: e.at }]);
            throw new ComponentValidationError(errorMsg);
        }
    }
    validateProjectSchema(input) {
        try {
            const cleanedUIDL = utils.validateNulls(input);
            const uidl = projectUIDLDecoder.runWithException(cleanedUIDL);
            return { valid: true, errorMsg: '', projectUIDL: uidl };
        }
        catch (e) {
            const errorMsg = utils.formatErrors([{ kind: e.kind, message: String(e), at: e.at }]);
            throw new ComponentValidationError(errorMsg);
        }
    }
    validateComponentContent(input) {
        const errorsInDefinitions = utils.checkDynamicDefinitions(input);
        const errorsWithLocalVariables = utils.checkForLocalVariables(input);
        utils.checkForDuplicateDefinitions(input);
        const errors = [...errorsInDefinitions, ...errorsWithLocalVariables];
        if (errors.length > 0) {
            throw new ComponentValidationError(`UIDL Component Content Validation Error. Please check the following: \n${errors}`);
        }
        return { valid: true, errorMsg: '' };
    }
    validateProjectContent(input) {
        const errorsOnRouteNode = utils.checkRouteDefinition(input) || [];
        let allErrors = errorsOnRouteNode;
        if (errorsOnRouteNode.length === 0) {
            const errorsInStyleSet = utils.checkProjectStyleSet(input);
            const errorsInRootComponent = utils.checkRootComponent(input);
            const errorsWithComponentNaming = utils.checkComponentNaming(input);
            const errorsWtihComponentExistence = utils.checkComponentExistenceAndReferences(input);
            allErrors = [
                ...errorsOnRouteNode,
                ...errorsWtihComponentExistence,
                ...errorsWithComponentNaming,
                ...errorsInRootComponent,
                ...errorsInStyleSet,
            ];
        }
        if (allErrors.length > 0) {
            throw new ProjectValidationError(`UIDL Project Content Validation Error. Please check the following: ${allErrors}`);
        }
        return { valid: true, errorMsg: '' };
    }
}
//# sourceMappingURL=index.js.map